import { PREVIEW, PROJECT_LINK } from "../../project-config";

export default function footerContent(langState, isLoggedIn) {
  let langCode = langState == "en" || langState == "tr" ? "" : `/${langState}`;

  const hideIfLoggedIn = () => {
    if (isLoggedIn) return { style: { display: isLoggedIn ? "none" : "" } };
    return {};
  };

  return {
    about: [
      {
        parent: { attributes: {} },
        children: [
          {
            attributes: {
              to: `/politique-de-confidentiialit`
            },
            text: "Avis juridique et Politique de confidentialité"
          },
          // {
          //   attributes: {
          //     to: `/shipping-information`
          //   },
          //   text: "Shipping Information"
          // },
          // {
          //   attributes: {
          //     to: `/return-policy`
          //   },
          //   text: "Return Policy"
          // },
          {
            attributes: {
              to: `/politique-daccessibilit-du-site-web`
            },
            text: "Politique d'accessibilité du site Web"
          },
          {
            attributes: {
              href: `javascript:window.OneTrust.ToggleInfoDisplay()`
            },
            text: "Ne pas vendre ou partager mes informations personnelles"
          }
        ]
      }
    ],

    shop: [
      {
        parent: { attributes: {} },
        children: [
          {
            attributes: {
              href: `mailto:cdncustserv@nebs.com`
            },
            text: "E-mail : cdncustserv@nebs.com"
          },
          {
            attributes: {
              to: `/contact`
            },
            text: "Contact"
          }
          // {
          //   attributes: {
          //     to: `/seller-registration`
          //   },
          //   text: "Seller Sign Up"
          // }
        ]
      }
    ],
    socialMedia: [
      {
        parent: { attributes: { className: "socialMedia" } },
        children: [
          {
            attributes: {
              target: "_blank",
              href: "https://www.facebook.com/avetticommerce",
              rel: "noopener noreferrer"
            },
            image: `Facebook`
          },
          {
            attributes: {
              target: "_blank",
              href: "https://www.linkedin.com/",
              rel: "noopener noreferrer"
            },
            image: `Linkedin`
          },

          {
            attributes: {
              target: "_blank",
              href: "https://www.twitter.com/avetticom",
              rel: "noopener noreferrer"
            },
            image: `Twitter`
          }
        ]
      }
    ]
  };
}
